const basePath = 'https://benefit-api.v4.kimbocare.dev';
const authBasePath = 'https://kimbo-dev.ddns.net/auth';
const marketingBasePath = 'https://kimbo-dev.ddns.net/marketing-api';
const paymentBasePath = 'https://kimbo-dev.ddns.net/payment-api';
const notificationBasePath = 'https://kimbo-dev.ddns.net/notifications-api'; 
const benefitBasePath = 'https://benefit-api.v4.kimbocare.dev/admin';
const benefitPath = 'https://benefit-api.v4.kimbocare.dev';
const kimboPath = 'https://api.v4.kimbocare.dev'; 

const kimboCampaignFees = 0.12;
const deeplApiKey = 'c33fc85c-93ff-4d12-a52c-130787e20571:fx';
const mapApiKey = 'AIzaSyAHqT1zAjqeka7Ha1mb33HL0lFM5B2IKmc';
export const environment = {
  production: false,
  serviceWorker: false,
  appId: 'benefit',
  vapid_key:
    'BI-9ryhqMrssYqhg5evENqNEzkBQTDK95eTca6d0DtP-fx5xDlwgnlayzZmu2P66IrT2PoDcS8S3NTp_Mjj8Hi8',
  google_client_id:
    '100180207220-7po6nvcajccccoalkr61k3me4uk2s8r1.apps.googleusercontent.com',
  mapApiKey,
  deeplApiKey,
  name: 'staging',
  appVersion: require('../../package.json').version,
  paymentBasePath,
  marketingBasePath,
  benefitBasePath,
  benefitPath,
  kimboPath,
  badge: true,
  basePath,
  notificationBasePath,
  authBasePath,
  apiProvider: 'api',
  sentry: {
    tracingOrigins: ['https://app.kimbocare.dev'],
  },
  kimboCampaignFees,
  recaptcha: {
    siteKey: '6LcRPTYmAAAAAArMl6NN16N_kXQaVOT7EGgczl5d',
  },
  ssk: 'we-sv-rtw--eüd-§$-fd',
  ssv: 'öer:gerv:vjdf+*dfe#e-ee,',
};
